import { Stack } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import ReactQuill, { Quill } from 'react-quill'
import FixSize from './FixSize'
import InsertLink from './InsertLink'
import ShowImages from './ShowImages'

const Inline = Quill.import('blots/inline')
class FURIGANA extends Inline {
  static blotName = 'furigana'
  static tagName = ['ruby', 'rt']

  static create(value: string) {
    const container = document.createElement('div')
    const node = document.createElement('ruby')
    const rt = document.createElement('rt')
    rt.innerText = 'カンジ'
    node.innerText = '漢字'
    node.appendChild(rt)
    container.appendChild(node)
    return container
  }

  static formats(domNode: { tagName: string }) {
    if (domNode.tagName === 'RUBY') return 'ruby'
    if (domNode.tagName === 'RT') return 'rt'
    return undefined
  }
}

Quill.register(FURIGANA)

interface Props {
  value: string
  setValue: (arg: string) => void
}
export default function RichTextEditor({ value = '', setValue }: Props) {
  const [text, setText] = useState(value)
  const [state, setState] = useState({
    selectImg: false,
    fixSize: false,
    insertLink: false,
    insertRuby: false,
    cursorPosition: 0,
  })
  const [selected, setSelected] = useState<string>('')
  let reactQuillRef = useRef<ReactQuill>(null)
  useEffect(() => {
    setValue(text)
  }, [setValue, text])
  useEffect(() => {
    if (reactQuillRef.current && reactQuillRef.current.editor) {
      const quill = reactQuillRef.current.editor
      reactQuillRef.current.editor
        .getModule('toolbar')
        .addHandler('image', () => {
          const cursorPosition = quill.getSelection(true).index
          setState({
            ...state,
            selectImg: true,
            cursorPosition,
          })
        })
      reactQuillRef.current.editor
        .getModule('toolbar')
        .addHandler('link', () => {
          const cursorPosition = quill.getSelection(true).index
          setState({
            ...state,
            insertLink: true,
            cursorPosition,
          })
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const addImage = (width: number) => {
    if (reactQuillRef.current && reactQuillRef.current.editor && selected) {
      const quill = reactQuillRef.current.editor
      quill.clipboard.dangerouslyPasteHTML(
        state.cursorPosition,
        `<img src="${selected}" width="${width}px"/>`
      )
    }
  }
  const addLink = ({
    target,
    title,
    url,
  }: {
    title: string
    url: string
    target: '_blank' | '_self'
  }) => {
    if (reactQuillRef.current && reactQuillRef.current.editor) {
      const Link = Quill.import('formats/link')
      console.log('src/components/RichTextEditor.tsx:84>>', Link)
      Link.create = function (url: string) {
        const node = document.createElement('a')
        node.setAttribute('href', url)
        if (target === '_blank') {
          node.setAttribute('rel', 'noopener noreferrer')
          node.setAttribute('target', target)
        }
        return node
      }
      Quill.register(Link, true)

      const quill = reactQuillRef.current.editor
      quill.clipboard.dangerouslyPasteHTML(
        state.cursorPosition,
        `<a href="${url}">${title}</a>`,
        'user'
      )
    }
  }
  return (
    <Stack>
      {state.selectImg && (
        <ShowImages
          open={state.selectImg}
          handleClose={() => {
            setState({ ...state, selectImg: false })
          }}
          handleSelect={(img) => {
            setSelected(img)
            setState({ ...state, selectImg: false, fixSize: true })
          }}
        />
      )}
      {state.insertLink && (
        <InsertLink
          open={state.insertLink}
          handleClose={() => {
            setState({ ...state, insertLink: false })
          }}
          handleSubmit={(link) => {
            setState({ ...state, insertLink: false })
            addLink(link)
          }}
        />
      )}
      {state.fixSize && selected && (
        <FixSize
          open={state.fixSize && !!selected}
          imgSrc={selected}
          handleClose={() => {
            setState({ ...state, selectImg: false, fixSize: false })
          }}
          handleSubmit={(width) => {
            setState({ ...state, selectImg: false, fixSize: false })
            addImage(width)
          }}
        />
      )}
      <ReactQuill
        ref={reactQuillRef}
        theme="snow"
        value={text}
        onChange={(value, _1, _2, _editor) => {
          setText(value)
        }}
        style={{
          minHeight: 200,
        }}
        placeholder="何か入力して下さい"
        modules={{
          toolbar: {
            container: toolbarOptions,
            handlers: {},
          },
          clipboard: {
            matchVisual: false,
          },
        }}
      />
    </Stack>
  )
}
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike', 'link', 'blockquote'], // toggled buttons
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }, { align: [] }],
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown

  [{ color: [] }, { background: [] }, 'image'],
]
